import React from "react";
import "./CloseComplaintProgressBar.scss";
import { useNavigate } from "react-router-dom";

const CloseComplaintProgressBar: React.FC = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate("/EComplaintDashboard");
  };

  return (
    <div className="overlay">
      <div className="progress-dialog">
        <div className="progress-content">
          <div className="icon_warning">
            <img
              src={require("../../assets/warning_image.gif")}
              alt="warning"
            />
          </div>
          <h4 className="dialog-header">Filing with Circuit Clerk</h4>
          <div className="text-content">
            <p>
              A Release on Own Recognizance is what schedules your case with the
              court.
              <br />
              Failure to file this document may result in your case not being
              heard.
            </p>
          </div>
          <div className="list-intro-div">
            <p>You must either</p>
          </div>
          <ul>
            <li>File electronically to this system, or</li>
            <li>
              Complete and return a paper Release on Own Recognizance to the
              <br />
              Circuit Clerk as soon as possible.
            </li>
          </ul>

          <button className="close-btn" onClick={handleClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default CloseComplaintProgressBar;
